// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"143":"app","998":"chunk-vendors"}[chunkId] + "." + {"143":"109beaeb","998":"af21401b"}[chunkId] + ".css";
};